export const DOCUMENT_TYPE_EXTENSION = {
	T_SOC: 'socweb',
	T_DOC: 'docweb',
	T_CURVES: 'docweb',
	T_OTC: 'otcweb',
};
